import ChipInAmount from './chip_in_amount'
import { reduxForm } from 'redux-form'
import { AMOUNT_TYPES, FUNDING_SOURCES } from 'shared/shared_consts'
import formUtils from 'lib/form_utils'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { chipInRemotely } from 'redux/modules/campaign'
import { glimpseRoute } from 'lib/route_utils'
import { push } from 'react-router-redux'
import { getFundingSources } from 'redux/modules/funding_sources'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/chip_in_glimpse/chip_in_amount')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const fundingSources = state.funding_sources.map
  const firstFS = fundingSources ? Object.keys(fundingSources)[0] : ''
  return {
    shouldAutoFocus: props.router.params.action !== 'POP',
    title: campaign.title,
    currency: campaign.currency,
    amountType: campaign.amount_type || AMOUNT_TYPES.any,
    amount: campaign.amount,
    fundingSources,
    fsLoading: state.funding_sources.operatingRemotely,
    fundingSourcesError: state.funding_sources.err,
    initialValues: {
      amount: campaign.amount_type !== AMOUNT_TYPES.any ? campaign.amount : 0,
      anonymous: false,
      funding: firstFS,
    },
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onLoadFundingSources() {
      dispatch(getFundingSources(campaignId)).catch(err => {
        // nop, the error object will be set in the funding_sources module
        // but, we still want to catch the rejected promise.
        console.error(err) // eslint-disable-line no-console
      })
    },
    onChipIn(fields) {
      dispatch(chipInRemotely(campaignId, fields))
        .then(() => {
          dispatch(push({ pathname: glimpseRoute('chip_in', 'complete') }))
        })
        .catch(() => {
          dispatch(push({ pathname: glimpseRoute('chip_in', 'complete') }))
        })
    },
  }
}

function amountValidator() {
  return (values, props) => {
    const amount = parseFloat(values.amount)

    let errorLabel = i18n('amount_required')
    if (!values.amount || amount === 0) {
      return { amount: errorLabel }
    }
    if (values.funding && props.fundingSources) {
      const fs = props.fundingSources[values.funding]
      if (fs.type === FUNDING_SOURCES.HOLDING && fs.balance.value < amount) {
        errorLabel = i18n('amount_more_than_balance')
        return { amount: errorLabel }
      }
    }
    return {}
  }
}

export default reduxForm(
  {
    form: 'chip_in',
    fields: ['amount', 'anonymous', 'funding'],
    destroyOnUnmount: false,
    touchOnChange: false,
    touchOnBlur: true,
    validate: amountValidator(),
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(ChipInAmount))
